import { FormGroup, FormControl } from "@angular/forms";

export var StatisticForm = new FormGroup({
    G3E_ID: new FormControl(),
    G3E_FNO: new FormControl(),
    G3E_CNO: new FormControl(),
    G3E_FID: new FormControl(),
    G3E_CID: new FormControl(),
    CONTRACT_ID: new FormControl(),
    ACTIVITY_TYPE: new FormControl(),
    REASON_TYPE: new FormControl(),
    BEGIN_ACTIVITY_DT: new FormControl(),
    END_ACTIVITY_DT: new FormControl(),
    NOTE: new FormControl(),
    FAULTY_REQUEST: new FormControl(),
    REQUEST_DT: new FormControl(),
    SEARCH_METHOD: new FormControl(),
    ADDRESS_ID: new FormControl(),
    RESPONSIBLE_PERSON: new FormControl(),
    RESPONSIBLE_PERSON_TEL_NUM: new FormControl(),
    LOCATION_DESC: new FormControl(),
    PARCEL_ID: new FormControl(),
    REQUEST_STATE: new FormControl(),
    DELIVERY_STATE: new FormControl(),
    EXPIRATION_DT: new FormControl(),
    MAIL_DT: new FormControl(),
    X_LOC_COORD: new FormControl(),
    Y_LOC_COORD: new FormControl(),
    PROJECT_NUM: new FormControl(),
    PERSON_ID: new FormControl(),
    FORMAT: new FormControl(),
    SCALE: new FormControl(),
    REQUESTOR: new FormControl(),
    PERSON_FWD: new FormControl(),
    INTNOTE: new FormControl(),
    PERSON_NOTIF: new FormControl(),
    REPLOT_NEW_FID: new FormControl(),
    RQTITLE: new FormControl(),
    REQERR_NOTIF: new FormControl(),
    PERSON_EMAIL: new FormControl(),
  });